import { useMemo } from 'react';
import { BUILT_IN_DESIGNS } from '../designs/catalog';
import { fontStack } from '../designs/fonts';
import { designLook, paperCss, resolveLook } from '../designs/look';
import { useStore } from '../state/store';
import type { Note } from '../storage/schemas';

/** Reference top-left button: a small stack of note cards labelled "Design"; the front card is the current design. */
export function DesignStackButton({ note, onClick }: { note: Note; onClick: () => void }) {
  const designs = useStore((s) => s.designs);
  const favorites = useStore((s) => s.settings.favoriteDesigns);
  const front = resolveLook(note, designs);
  const back = useMemo(() => {
    // Two other designs peek out behind: favourites first, otherwise neighbours in the gallery.
    const pool = [...favorites.map((id) => BUILT_IN_DESIGNS.find((d) => d.id === id)).filter(Boolean), ...BUILT_IN_DESIGNS.filter((d) => d.category === 'Colorful' || d.category === 'Retro')];
    const others = pool.filter((d) => d && d.id !== note.designId);
    const i = Math.abs([...note.designId].reduce((h, c) => h * 31 + c.charCodeAt(0), 7)) % Math.max(1, others.length - 1);
    return [others[i], others[(i + 1) % others.length]].map((d) => designLook(d!));
  }, [favorites, note.designId]);
  return (
    <button type="button" className="design-stack" onClick={onClick} aria-label="Designs">
      <span className="ds-card is-back2" style={{ background: paperCss(back[1]) }} aria-hidden="true" />
      <span className="ds-card is-back1" style={{ background: paperCss(back[0]), color: back[0].ink, fontFamily: fontStack(back[0].font) }} aria-hidden="true">
        Design
      </span>
      <span className="ds-card is-front" style={{ background: paperCss(front), color: front.ink, fontFamily: fontStack(front.font) }} aria-hidden="true">
        Design
      </span>
    </button>
  );
}
